function cartCount(){
  $.getJSON('/cart.js', function(cart) { 
    $(".cart-count-bubble > span").html(cart.item_count); 
    if(cart.item_count >= 1){
    $('#cart-icon-bubble').append('<div class="cart-count-bubble" bis_skin_checked="1"><span aria-hidden="true">'+cart.item_count+'</span><span class="visually-hidden">'+cart.item_count+' items</span></div>')}
  });
}
function updateMiniCart() {
  $.ajax({
    type: "GET", 
    url: "/", // Ensure this URL returns the correct HTML snippet for the mini cart
    dataType: 'html',
    success: function(data) {
      // Log the full response to debug and confirm the structure
      console.log(data);
      
      // Select the mini cart content from the returned HTML response
      var miniCartHead = $(data).find('.cart-drawer-container #mini-cart').html(); 

      if (miniCartHead) {
        // Update the mini cart with the new content
        console.log('Mini Cart Content:', miniCartHead);
        // $('#mini-cart').html(miniCartHead);  // Update the mini cart section
      } else {
        console.error('Mini cart content not found.');
      }
    },
    error: function(xhr) {
      console.error('Error fetching mini cart HTML:', xhr);
    }
  });
}
/*************12-12-2023*****************/

$(document).ready(function(){
  setTimeout(function(){
    $('.main___product .product__info-container .subscription_type .one_time').click();
  }, 500);
  $(document).on('click', '.sticky_button__selector .sticky_selector_button', function () {
    // console.log("click");
    var mainValuelabel = $(this).parents('.sticky_button__selector').attr('name');
    var mainValue = $(this).attr('value');
    // console.log(mainValuelabel);
    // console.log(mainValue);
    $(this).siblings('.sticky_selector_button').removeClass('active');
    $(this).parents('.main___product').find('.product__info-container .variant-input-wrapper input[value="'+mainValue+'"]').click();
    $(this).parents('.sticky-cart__form').find('.sticky_option_selector select-wrapper .select__select[name="'+mainValuelabel+'"]').val(mainValue).change();
    $(this).addClass('active');
  });

  $(document).on('click', '.main___product .product__info-container .variant-input-wrapper input', function () {
    var mainValuelabel = $(this).attr('name');
    var mainValue = $(this).attr('value');
    var varrId = $(this).attr('variant__id');
    var ThisProdAvail = $(this).attr('data-varaint-availability');
    var sellingPricefirst = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('sell_original_price');
    var sellingPricedecimal = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('sell_original_decimal');
    var com_originalPricefirst = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('original_price');
    var com_originalPricedecimal = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('original_decimal');
    var discountPrice = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('non_sell_price-discount');
    var sub_discountPrice = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('sell_price-discount');
    var dataComparePrice = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('data-compare-price');
    var currencySymbol = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('currency_symbol');
    var $sub = $(this).parents('.product__info-container').find('.subscription_type .subscribe');

    var sub_discountOringanlPrice = parseFloat($(this).parents('.product__info-container').find('.product-form__input input:checked').attr('original__price'));
    var sub_discountSellingPrice = parseFloat($(this).parents('.product__info-container').find('.product-form__input input:checked').attr('selling__price'));
    var OGdiscountAmount = sub_discountOringanlPrice - sub_discountSellingPrice;
    var OGdiscountPercent = (OGdiscountAmount / sub_discountOringanlPrice) * 100;
    OGdiscountPercent = OGdiscountPercent.toFixed(0);
    // console.log(mainValuelabel);
    // console.log(mainValue);
    // $('.sticky_selector_button').removeClass('active');
    $(this).parents('.main___product').find('.sticky-cart__form .sticky_option_selector select-wrapper .select__select[name="'+mainValuelabel+'"]').val(mainValue).change();
    $(this).parents('.main___product').find('.sticky_button__selector[name="'+mainValuelabel+'"] .sticky_selector_button').siblings('.sticky_selector_button').removeClass('active');
    $(this).parents('.main___product').find('.sticky_button__selector[name="'+mainValuelabel+'"] .sticky_selector_button[value="'+mainValue+'"]').addClass('active');
    // console.log('com_originalPricefirst::'+com_originalPricefirst+ ' '+ 'com_originalPricedecimal::'+com_originalPricedecimal);
    // $sub.trigger('click');
    if($sub.hasClass('active')) {
      
      $('.price_loader').removeClass('hide');
      setTimeout(function() {
        $('.main___product  .product__info-container').find('.price .price__sale .price__compare .price-item--regular bdi').empty();
        $('.main___product  .product__info-container').find('.price .price__sale .price-item--sale bdi').empty();
        $('.main___product .product__info-container').find('.price').addClass('price--on-sale');
        $('.main___product .product__info-container').find('.price .price__sale .price-item--sale bdi').append('<span class="price__prefix">' + currencySymbol + '</span>' + sellingPricefirst + '<sup class="price__suffix">' + sellingPricedecimal + '</sup>');
        $('.main___product .product__info-container').find('.price .price__sale .price-item--regular bdi').append('<span class="price__prefix">' + currencySymbol + '</span>' + com_originalPricefirst + '<sup class="price__suffix">' + com_originalPricedecimal + '</sup>');
        $('.main___product .product__info-container').find('.price .price__badge-sale').text(OGdiscountPercent + '% OFF');
        
        // sticky desktop
        if ($(window).width() >= 750) {
          $('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__sale .price-item--regular bdi').empty();
          $('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__sale .price-item--sale bdi').empty();
          $('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price').addClass('price--on-sale');
          $('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__sale .price-item--regular bdi').append('<span class="price__prefix">' + currencySymbol + '</span>' + com_originalPricefirst + '<sup class="price__suffix">' + com_originalPricedecimal + '</sup>');
          $('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__sale .price-item--sale bdi').append('<span class="price__prefix">' + currencySymbol + '</span>' + sellingPricefirst + '<sup class="price__suffix">' + sellingPricedecimal + '</sup>');
          $('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__badge-sale').text(OGdiscountPercent + '% OFF');
        }
      }, 1200);
      setTimeout(function() {
        $('.price_loader').addClass('hide');
      }, 1400);
    }
    if (ThisProdAvail == 'true'){
      $('.main___product .selling_plan_sticky .subscription_sticky_cart .sticky-cart__form').find('.sticky_selling_add').removeAttr('disabled');
            $('.main___product .selling_plan_sticky .subscription_sticky_cart .sticky-cart__form').find('.sticky_price .selling__price').removeClass('price--sold-out');
      $('.main___product .selling_plan_sticky .subscription_sticky_cart .sticky-cart__form').find('.sticky_selling_add').text('Add to cart');
    }else{
      $('.main___product .selling_plan_sticky .subscription_sticky_cart .sticky-cart__form').find('.sticky_selling_add').attr('disabled', 'true');
            $('.main___product .selling_plan_sticky .subscription_sticky_cart .sticky-cart__form').find('.sticky_price .selling__price').addClass('price--sold-out');
      $('.main___product .selling_plan_sticky .subscription_sticky_cart .sticky-cart__form').find('.sticky_selling_add').text('Sold out');
    }
    // setTimeout(function() {
    //   $('.main___product').find('.subscription_sticky_cart .sticky-cart__form .price .price__regular .price-item--regular bdi').contents().filter(function() {
    //         return !$(this).hasClass('price__prefix');
    //       }).remove();
    //       $('.main___product').find('.subscription_sticky_cart .sticky-cart__form .price .price__regular .price-item--regular bdi').append(com_originalPricefirst + '<sup class="price__suffix">' + com_originalPricedecimal + '</sup>');
    //       $('.main___product').find('.subscription_sticky_cart .sticky-cart__form .price .price__regular .price-item--sale bdi').append(sellingPricefirst + '<sup class="price__suffix">' + sellingPricedecimal + '</sup>');
    //       $('.main___product').find('.subscription_sticky_cart .sticky-cart__form .price .price__badge-sale').text(sub_discountPrice);
    //       $('.main___product').find('.subscription_sticky_cart .sticky-cart__form .price .price__sale .price-item--regular bdi').contents().filter(function() {
    //         return !$(this).hasClass('price__prefix');
    //       }).remove();
    //       $('.main___product').find('.subscription_sticky_cart .sticky-cart__form .price .price__sale .price-item--sale bdi').contents().filter(function() {
    //         return !$(this).hasClass('price__prefix');
    //       }).remove();
    //       $('.main___product').find('.subscription_sticky_cart .sticky-cart__form .price .price__sale .price-item--regular bdi').append(com_originalPricefirst + '<sup class="price__suffix">' + com_originalPricedecimal + '</sup>');
    //       $('.main___product').find('.subscription_sticky_cart .sticky-cart__form .price .price__sale .price-item--sale bdi').append(sellingPricefirst + '<sup class="price__suffix">' + sellingPricedecimal + '</sup>');
    //       $('.main___product').find('.subscription_sticky_cart .sticky-cart__form .price').addClass('price--on-sale');
    //   }, 1200);
  });

 $(document).on('change', '.selling_plan_sticky .sticky-cart__form .product-form__input .select .select__select', function () {
    var mainValue = $(this).val();
    var jsonData = JSON.parse($('.product-sticky-cart .sticky-cart__form .sticky_option_selector script').html().trim());
    var selectedVariant = jsonData.find(function(variant) {
        return variant.title.trim() === mainValue.trim();
    });
    
    if (selectedVariant) {
        var ThisProdAvail = selectedVariant.available;
        if (ThisProdAvail == true) {
            $('.main___product .selling_plan_sticky .subscription_sticky_cart .sticky-cart__form').find('.sticky_selling_add').removeAttr('disabled');
            $('.main___product .selling_plan_sticky .subscription_sticky_cart .sticky-cart__form').find('.sticky_price .selling__price').removeClass('price--sold-out');
            $('.main___product .selling_plan_sticky .subscription_sticky_cart .sticky-cart__form').find('.sticky_selling_add').text('Add to cart');
        } else {
            $('.main___product .selling_plan_sticky .subscription_sticky_cart .sticky-cart__form').find('.sticky_selling_add').attr('disabled', 'true');
            $('.main___product .selling_plan_sticky .subscription_sticky_cart .sticky-cart__form').find('.sticky_price .selling__price').addClass('price--sold-out');
            $('.main___product .selling_plan_sticky .subscription_sticky_cart .sticky-cart__form').find('.sticky_selling_add').text('Sold out');
        }
    } else {
        console.log('Selected variant not found in JSON data');
    }
    
    var mainValuelabel = $(this).parents('.select').attr('name');
    var mainValue = $(this).val();
    var com_originalPricefirst = $(this).parents('.main___product').find('.product__info-container .product-form__input input[value="'+mainValue+'"]').prop('checked', true);
    var com_originalPricefirst = $(this).parents('.main___product').find('.product__info-container .product-form__input input[value="'+mainValue+'"]').attr('original_price');
    var com_originalPricedecimal = $(this).parents('.main___product').find('.product__info-container .product-form__input input[value="'+mainValue+'"]').attr('original_decimal');
    var sellingPricefirst = $(this).parents('.main___product').find('.product__info-container .product-form__input input[value="'+mainValue+'"]').attr('sell_original_price');
    var sellingPricedecimal = $(this).parents('.main___product').find('.product__info-container .product-form__input input[value="'+mainValue+'"]').attr('sell_original_decimal');
    var sellingDiscount = $(this).parents('.main___product').find('.product__info-container .product-form__input input[value="'+mainValue+'"]').attr('sell_price-discount');
    var $sub = $(this).parents('.main___product').find('.product__info-container .subscription_type .subscribe');
    // if($sub.hasClass('active')) {
    //   setTimeout(function() {
    //     $('.main___product .product__info-container').find('.price .price__regular .price-item--regular bdi').contents().filter(function() {
    //       return !$(this).hasClass('price__prefix');
    //     }).remove();
    //     $('.main___product .product__info-container').find('.price .price__sale .price-item--sale bdi').contents().filter(function() {
    //       return !$(this).hasClass('price__prefix');
    //     }).remove();
    //     $('.main___product .product__info-container').find('.price .price__regular .price-item--regular bdi').append(sellingPricefirst + '<sup class="price__suffix">' + sellingPricedecimal + '</sup>');
    //     $('.main___product .product__info-container').find('.price .price__sale .price-item--regular bdi').append(com_originalPricefirst + '<sup class="price__suffix">' + com_originalPricedecimal + '</sup>');
    //     $('.main___product .product__info-container').find('.price .price__sale .price-item--sale bdi').append(sellingPricefirst + '<sup class="price__suffix">' + sellingPricedecimal + '</sup>');
    //     $('.main___product .product__info-container').find('.price').addClass('price--on-sale');
    //     $('.main___product .product__info-container').find('.price .price__badge-sale').text(sellingDiscount);
    //   }, 1200);
    // }
    $(this).parents('.main___product').find('.select__select[name="selling_plan_stick_mobile"]').prop('selectedIndex', 0).trigger('change');
    $('.main___product .selling_plan_sticky .subscription_sticky_cart').find('.price .price__sale .price-item--regular bdi').contents().filter(function() {
      return !$(this).hasClass('price__prefix');
    }).remove();
    $('.main___product .selling_plan_sticky .subscription_sticky_cart').find('.price .price__sale .price-item--sale bdi').contents().filter(function() {
      return !$(this).hasClass('price__prefix');
    }).remove();
    $('.main___product .selling_plan_sticky .subscription_sticky_cart').find('.price .price__sale .price-item--regular bdi').append(com_originalPricefirst + '<sup class="price__suffix">' + com_originalPricedecimal + '</sup>');
    $('.main___product .selling_plan_sticky .subscription_sticky_cart').find('.price .price__sale .price-item--sale bdi').append(sellingPricefirst + '<sup class="price__suffix">' + sellingPricedecimal + '</sup>');
  });

  $(window).scroll(function() {
    if ($(window).scrollTop() >= $(document).height() - $(window).height() - 500) {
        $('.sticky-cart-wrapper').addClass('stop__sticky');
    } else {
        $('.sticky-cart-wrapper').removeClass('stop__sticky');
    }
  });
  $(document).on('click', '.countery-picker-list li', function(){
    var $thisDataVal = $(this).attr('value');
    var $thisDataText = $(this).text();
    let $Woking_text = $(this).attr('data-text');
    console.log('$Woking_text'+ $Woking_text);
    console.log('$thisDataVal::-'+$thisDataVal);
    $('.country-picker').val($thisDataVal).change();
    $('.ship__text__country').text($thisDataText);
    $('.cdk-country-name .country--name').text($thisDataText);
    if ($Woking_text !== undefined){
      $('.data-text-update').text($Woking_text);
    }
    else{
      $('.data-text-update').text('5-10 WORKING DAYS');
    }
    
    $(this).parents('.countery-picker-list').addClass('show');
    $('.currency-name .label').removeClass('active');
    $('.shipping-drawer_close').click();
  })
  $('.currency-name .label').click(function(){
        $(this).toggleClass('active');
        $('.countery-picker-list').toggleClass('show');
  });
  $(document).on('click','.shipping-drawer_close', function(){
    $('.currency-name .label').removeClass('active');
    $('.countery-picker-list').removeClass('show');
    $(".shipping-drawer-overlay").removeClass('show');
    $("body").removeClass('language_drawer_open');
    $(".custom-overlay").fadeOut(200);
  })
  $(document).on("mouseup", function(event){
      if(!$(event.target).closest(".shipping_container").length) {
          $(".shipping-drawer-overlay").removeClass('show');
          $("body").removeClass('language_drawer_open');
          $(".custom-overlay").fadeOut(200);
      }
    });
  // $(document).on("mouseup", function(event){
  //       if(!$(event.target).closest(".currency-name").length && !$(event.target).closest(".countery-picker-list").length) {
  //           $('.currency-name .label').removeClass('active');
  //           $('.countery-picker-list').removeClass('show');
  //       }
  //   });
  $(document).mouseup(function(e){
  var container = $(".menu-drawer-country .currency-picker__wrapper .label");
    if(!container.is(e.target) && container.has(e.target).length === 0){
      $('.currency-name .label').removeClass('active');
      $('.countery-picker-list').removeClass('show');
    }
  });
  $(document).on("click", '.cdk-shipping-header',function(event){
    event.preventDefault();
    // console.log('click');
    $(".custom-overlay").fadeIn(200);
    $(".shipping-drawer-overlay").addClass('show');
    $("body").addClass('language_drawer_open');
  });
  $(document).on('change', '.country-picker', function() {
    var  $thisval = $(this).val().toLowerCase();
    var $newClass = 'currency-flag currency-flag--'+$thisval;
    console.log('$thisval::'+$thisval+'$newClass::'+$newClass);
    // $(this).parents('.currency-picker__wrapper').find('.currency-flag').attr('class',' ');
    $(this).parents('.currency-picker__wrapper').find('.currency-flag').attr("class",$newClass);
    $('.cdesk_country_flag_icon').find('.currency-flag').attr("class",$newClass);
    // $(this).next('.currency-picker__wrapper').slideToggle();
    $(this).next('.currency-picker__wrapper').find('.country-picker').trigger('click');
  })
  
  $(document).on('click','.card-wrapper .swatches-block .swatches-item-box .swatches-option', function () {
    var OptionName = $(this).attr('data-value');
    $(this).parents('.swatches-item-box').find('.swatches-option').removeClass('selected');
    $(this).addClass('selected');
    $(this).parents('.swatches-block').find('select').val(OptionName).change();
    console.log("OptionName::"+OptionName);
  })

  $(document).on('change','.card-wrapper .swatches-block select', function () {
    var FinalValue = '';
    var thisParentId = $(this).parents('.card-wrapper').attr('id');
    console.log('thisParentId::'+thisParentId);
    // $('.quick-view-wrapper[data-id="'+thisParentId+'"] .swatches-block').each(function() {
      var selectVal = $(this).val();
      FinalValue += selectVal+' / ';
      console.log('selectVal::'+selectVal);
    // });
    var newstr = FinalValue.substring(0, FinalValue.length - 3);
      console.log('newstr::'+newstr);
 
    
    var optionName_Selector = $('.card-wrapper[id="'+thisParentId+'"] select.product_card-form__master-select option[check-data-sku="'+newstr+'"]')
     var optionName_val = optionName_Selector.val();
    $('.card-wrapper[id="'+thisParentId+'"] select.product_card-form__master-select').val(optionName_val).change();
 
    })

    $(document).on('change','.card-wrapper select.product_card-form__master-select', function () {
        var thisMainVal = $(this).val(); 
        var thisParentId = $(this).parents('.card-wrapper').attr('id');
        console.log('thisMainVal::'+thisMainVal);
        var ThisProdName =$(this).find('option[value="'+thisMainVal+'"]').attr('check-data-sku');
        console.log('ThisProdName::'+ThisProdName);
        var ThisProdAvail =$(this).find('option[value="'+thisMainVal+'"]').attr('data-varaint-availability');
        var ThisComparePrice =$(this).find('option[value="'+thisMainVal+'"]').attr('data-compare');
        var ThisPrice =$(this).find('option[value="'+thisMainVal+'"]').attr('data-price');
        var priceContainer = $('.card-wrapper[id="' + thisParentId + '"]').find('.product-form + .price');
        var priceContainer = $('.card-wrapper[id="' + thisParentId + '"]').find('.price');
        // Check if the selected option has the 'compare_price' attribute
        var hasCompareAttribute = $(this).find('option[value="' + thisMainVal + '"]').attr('compare_price') !== undefined;
      // console.log('ThisComparePrice::'+ThisComparePrice+ ' '+ 'ThisPrice::'+ ThisPrice);
        $('.card-wrapper[id="'+thisParentId+'"]').find('.price .price-item--regular').html(ThisComparePrice);
        $('.card-wrapper[id="'+thisParentId+'"]').find('.price .price--on-sale').html(ThisPrice);
        if (hasCompareAttribute) {
            priceContainer.addClass('price--on-sale');
        } else {
            priceContainer.removeClass('price--on-sale');
        }
        if (ThisProdAvail == 'true'){
          $('.card-wrapper[id="'+thisParentId+'"]').find('.product-form__submit .sold-out').remove();
          $('.card-wrapper[id="'+thisParentId+'"]').find('.product-form__submit').removeClass('sold-out');
          $('.card-wrapper[id="'+thisParentId+'"]').find('.product-form__submit svg').show();
          $('.card-wrapper[id="'+thisParentId+'"]').find('form .card-wrapper-id').val(thisParentId);
          $('.card-wrapper[id="'+thisParentId+'"]').find('.product-form + .price .badge--soldout').remove();
          $('.card-wrapper[id="'+thisParentId+'"]').find('.product-form + .price').removeClass('price--sold-out');
        }else{
          // $('.card-wrapper[id="'+thisParentId+'"]').find('.product-form__submit svg').hide();
          $('.card-wrapper[id="'+thisParentId+'"]').find('.product-form .swatches-item-box .swatches-option[data-value="' + ThisProdName + '"]').addClass('disabled');
          $('.card-wrapper[id="'+thisParentId+'"]').find('.product-form__submit').addClass('sold-out');
          $('.card-wrapper[id="'+thisParentId+'"]').find('.product-form + .price').addClass('price--sold-out');
          if (priceContainer.find('.badge--soldout').length === 0) {
            priceContainer.append('<span class="badge badge--soldout" aria-hidden="true"> Sold out </span>');
          }
        } 
        
      });

  // selling plan

  $(document).on('click','.subscription_type .one_time', function () {
    var originalPricefirst = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('original_price');
    var originalPricedecimal = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('original_decimal');
    var com_originalPricefirst = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('compare_price');
    var com_originalPricedecimal = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('compare_price_decimal');
    var discountPrice = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('non_sell_price-discount');
    var dataComparePrice = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('data-compare-price');
    var $bdiElement = $(this).parents('.product__info-container').find('.price .price__regular .price-item--regular bdi');
    var $regularbdiElement = $(this).parents('.product__info-container').find('.price .price__sale .price-item--regular bdi');
    var $salebdiElement = $(this).parents('.product__info-container').find('.price .price__sale .price-item--sale bdi');
    var $currencySymbol = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('currency_symbol');
    
    
    $('.subscription_type .subscribe').removeClass('active');
    $('.subscription_type .subscribe_desktop').removeClass('active');
    $(this).parents('.product__info-container').find('.selling__id').val('');
    $('.subscription_cart_desktop product-form.sticky-cart__form form .selling_sticky_id_desktop').val('');
    $(this).addClass('active');
    $('.subscription_type .one_time_desktop').addClass('active');
    $('.subscription_select_box .subscription_option').hide();
    $('.subscription_select_box .subscription_list').hide();
    $('.subscription_select_box .onetime_list').show();
    if(dataComparePrice !== ''){
      $regularbdiElement.empty();
      $salebdiElement.empty();
      $(this).parents('.product__info-container').find('.price .price__sale .price-item--regular bdi').append('<span class="price__prefix">' + $currencySymbol + '</span>' + com_originalPricefirst + '<sup class="price__suffix">' + com_originalPricedecimal + '</sup>');
      $(this).parents('.product__info-container').find('.price .price__sale .price-item--sale bdi').append('<span class="price__prefix">' + $currencySymbol + '</span>' + originalPricefirst + '<sup class="price__suffix">' + originalPricedecimal + '</sup>');
      $(this).parents('.product__info-container').find('.price .price__badge-sale').text(discountPrice);
      $(this).parents('.product__info-container').find('.price').addClass('price--on-sale');
    }
    else{
      $(this).parents('.product__info-container').find('.price').removeClass('price--on-sale');
    }
     // sticky desktop
    if ($(window).width() >= 750) {
      
      
      if(dataComparePrice !== ''){
        $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__sale .price-item--regular bdi').empty();
        $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__sale .price-item--sale bdi').empty();
        // $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__regular .price-item--regular bdi').append(sellingPricefirst + '<sup class="price__suffix">' + sellingPricedecimal + '</sup>');
        $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__sale .price-item--sale bdi').append('<span class="price__prefix">' + $currencySymbol + '</span>' + originalPricefirst + '<sup class="price__suffix">' + originalPricedecimal + '</sup>');
        $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__sale .price-item--regular bdi').append('<span class="price__prefix">' + $currencySymbol + '</span>' + com_originalPricefirst + '<sup class="price__suffix">' + com_originalPricedecimal + '</sup>');
        $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price').addClass('price--on-sale');
        $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .badge').text(discountPrice);
      }
      
      else{
        $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price').removeClass('price--on-sale');
      }
    }
  });

  $(document).on('click','.subscription_type .subscribe', function () {
    var sellingPricefirst = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('sell_original_price');
    var sellingPricedecimal = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('sell_original_decimal');
    var com_originalPricefirst = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('original_price');
    var com_originalPricedecimal = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('original_decimal');
    var discountPrice = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('sell_price-discount');
    var $currencySymbol = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('currency_symbol');
    var $bdiElement = $(this).parents('.product__info-container').find('.price .price__regular .price-item--regular bdi');
    var $salebdiElement = $(this).parents('.product__info-container').find('.price .price__sale .price-item--regular bdi');
    var $comparebdiElement = $(this).parents('.product__info-container').find('.price .price__sale .price-item--sale bdi');
    var dataComparePrice = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('data-compare-price');
    // $bdiElement.contents().filter(function() {
    //     return !$(this).hasClass('price__prefix');
    // }).remove();
    // $comparebdiElement.contents().filter(function() {
    //     return !$(this).hasClass('price__prefix');
    // }).remove();
    // $salebdiElement.contents().filter(function() {
    //     return !$(this).hasClass('price__prefix');
    // }).remove();
    $comparebdiElement.empty();
    $salebdiElement.empty();
    console.log(sellingPricefirst);
    console.log(sellingPricedecimal);
    $('.subscription_type .one_time').removeClass('active');
    $('.subscription_type .one_time_desktop').removeClass('active');
    var sellingId = $(this).parents('.subcription_selector').find('.subscription_select_box.select .select__select').val();
    $(this).parents('.product__info-container').find('.selling__id').val(sellingId);
    $(this).addClass('active');
    $('.subscription_type .subscribe_desktop').addClass('active');
    $('.subscription_select_box .subscription_option').show();
    $('.subscription_select_box .subscription_list').show();
    $('.subscription_select_box .onetime_list').hide();
    $(this).parents('.subcription_selector').find('.subscription_select_box.select .select__select').prop('selectedIndex', 0).trigger('change');
    $(this).parents('.main___product').find('.subscription__wrappper_desktop .subscription_select_box .select__select').prop('selectedIndex', 0).trigger('change');
    
  });

  $(document).on('change', '.subscription_select_box.select .select__select', function () {
    var thisValue = $(this).val();

    // Find selected variant
    var selectedvar = $(this).parents('.main___product').find('.product__info-container .product-form__input input:checked').attr('variant__id');

    // Find the variant's selling plan select
    var $selectedselling = $(this).parents('.main___product').find('.product__info-container .variant-selling-plan[data-variant-id="' + selectedvar + '"]');

    // Set value and get the selected option
    $selectedselling.val(thisValue).change();
    var selectedOption = $selectedselling.find('option:selected');

    // Get pricing data
    var sellingPrice = selectedOption.attr('sell_original_price');
    var sellingPricedecimal = selectedOption.attr('sell_original_decimal');
    var com_originalPricefirst = selectedOption.attr('original_price');
    var com_originalPricedecimal = selectedOption.attr('original_decimal');
    var discountPrice = selectedOption.attr('discount');
    var $currencySymbol = selectedOption.attr('currency_symbol') || '$';
    var stickysellingPrice = selectedOption.attr('sell_original_price');
    var stickysellingPricedecimal = selectedOption.attr('sell_original_decimal');
    var stickycom_originalPricefirst = selectedOption.attr('original_price');
    var stickycom_originalPricedecimal = selectedOption.attr('original_decimal');
    var stickydiscountPrice = selectedOption.attr('discount');
    var $stickycurrencySymbol = selectedOption.attr('currency_symbol') || '$';
    var $bdiElement = $(this).parents('.product__info-container').find('.price .price__regular .price-item--regular bdi');
    var $salebdiElement = $(this).parents('.product__info-container').find('.price .price__sale .price-item--regular bdi');
    var $comparebdiElement = $(this).parents('.product__info-container').find('.price .price__sale .price-item--sale bdi');
    var dataComparePrice = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('data-compare-price');

    $comparebdiElement.empty();
    $salebdiElement.empty();
    console.log(sellingPrice);
    console.log(sellingPricedecimal);

    $(this).parents('.product__info-container').find('.price .price__sale .price-item--regular bdi').append('<span class="price__prefix">' + $currencySymbol + '</span>' + com_originalPricefirst + '<sup class="price__suffix">' + com_originalPricedecimal + '</sup>');
    $(this).parents('.product__info-container').find('.price .price__sale .price-item--sale bdi').append('<span class="price__prefix">' + $currencySymbol + '</span>' + sellingPrice + '<sup class="price__suffix">' + sellingPricedecimal + '</sup>');

    // Update discount badge
    var $discountBadge = $(this).closest('.product__info-container').find('.price .price__badge-sale');
    if (discountPrice < 1) {
        $discountBadge.addClass('hidden'); // hide if discount < 1%
        $salebdiElement.parents('.price__compare').addClass('hidden');
    } else {
        $salebdiElement.parents('.price__compare').removeClass('hidden');
        $discountBadge.removeClass('hidden').text(discountPrice + '% off'); // show otherwise
    }

    $(this).closest('.product__info-container').find('.price').addClass('price--on-sale');

    if ($(window).width() >= 750) {
      $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__sale .price-item--regular bdi').empty();
      $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__sale .price-item--sale bdi').empty();
      // $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__regular .price-item--regular bdi').append(sellingPricefirst + '<sup class="price__suffix">' + sellingPricedecimal + '</sup>');
      $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__sale .price-item--sale bdi').append('<span class="price__prefix">' + $stickycurrencySymbol + '</span>' + stickysellingPrice + '<sup class="price__suffix">' + stickysellingPricedecimal + '</sup>');
      $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__sale .price-item--regular bdi').append('<span class="price__prefix">' + $stickycurrencySymbol + '</span>' + stickycom_originalPricefirst + '<sup class="price__suffix">' + stickycom_originalPricedecimal + '</sup>');
      $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price').addClass('price--on-sale');
      var $stickydiscountBadge = $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__badge-sale');
      if (stickydiscountPrice < 1) {
          $stickydiscountBadge.addClass('hidden'); // hide if discount < 1%
          $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__sale .price-item--regular bdi').parents('.price__compare').addClass('hidden');
      } else {
          $(this).parents('.main___product').find('.subscription_cart_desktop .sticky-cart__form .price .price__sale .price-item--regular bdi').parents('.price__compare').removeClass('hidden');
          $stickydiscountBadge.removeClass('hidden').text(stickydiscountPrice + '% off'); // show otherwise
      }
    }

    // Update hidden fields
    $(this).parents('.product__info-container').find('.selling__id').val(thisValue);
    $(this).parents('.main___product').find('.subscription_cart_desktop product-form.sticky-cart__form form .selling_sticky_id_desktop').val(thisValue);
  });

  $(document).on('change','.selling_plan_sticky .sticky-cart .sticky_selling_select_box .select__select', function () {
     var thisValue = $(this).val();
     // new code
    var selectedvar = $(this).parents('.main___product').find('.product__info-container .product-form__input input:checked').attr('variant__id');
    var $selectedselling = $(this).parents('.main___product').find('.product__info-container .variant-selling-plan[data-variant-id="' + selectedvar + '"]');
    $selectedselling.val(thisValue).change();
    var selectedOption = $selectedselling.find('option:selected');
    var sellingPrice = selectedOption.attr('sell_original_price');
    var sellingPricedecimal = selectedOption.attr('sell_original_decimal');
    var com_originalPricefirst = selectedOption.attr('original_price');
    var com_originalPricedecimal = selectedOption.attr('original_decimal');
    var discountPrice = selectedOption.attr('discount');
    var $currencySymbol = selectedOption.attr('currency_symbol') || '$';
    var $stickycurrencySymbol = selectedOption.attr('currency_symbol') || '$';
    var $bdiElement = $(this).parents('.product__info-container').find('.price .price__regular .price-item--regular bdi');
    var $salebdiElement = $(this).parents('.product__info-container').find('.price .price__sale .price-item--regular bdi');
    var $comparebdiElement = $(this).parents('.product__info-container').find('.price .price__sale .price-item--sale bdi');
    var dataComparePrice = $(this).parents('.product__info-container').find('.product-form__input input:checked').attr('data-compare-price');

    $(this).parents('.main___product').find('.selling_plan_sticky .subscription_sticky_cart .price .price__sale .price-item--regular bdi').empty();
    $(this).parents('.main___product').find('.selling_plan_sticky .subscription_sticky_cart .price .price__sale .price-item--sale bdi').empty();
    $(this).parents('.main___product').find('.selling_plan_sticky .subscription_sticky_cart .price .price__sale .price-item--sale bdi').append('<span class="price__prefix">' + $currencySymbol + '</span>' + sellingPrice + '<sup class="price__suffix">' + sellingPricedecimal + '</sup>');
    $(this).parents('.main___product').find('.selling_plan_sticky .subscription_sticky_cart .price .price__sale .price-item--regular bdi').append('<span class="price__prefix">' + $currencySymbol + '</span>' + com_originalPricefirst + '<sup class="price__suffix">' + com_originalPricedecimal + '</sup>');
    $(this).parents('.main___product').find('.selling_plan_sticky .subscription_sticky_cart .price').addClass('price--on-sale');
    var $discountBadge = $(this).parents('.main___product').find('.selling_plan_sticky .subscription_sticky_cart .price .price__badge-sale');
    if (discountPrice < 1) {
        $discountBadge.addClass('hidden'); // hide if discount < 1%
        $(this).parents('.main___product').find('.selling_plan_sticky .subscription_sticky_cart .price .price__sale .price-item--regular bdi').parents('.price__compare').addClass('hidden');
    } else {
        $(this).parents('.main___product').find('.selling_plan_sticky .subscription_sticky_cart .price .price__sale .price-item--regular bdi').parents('.price__compare').removeClass('hidden');
        $discountBadge.removeClass('hidden').text(discountPrice + '% off'); // show otherwise
    }
     // console.log(thisValue);
    $(this).parents('.selling_plan_sticky').find('.selling__id_sticky').val(thisValue);
  });

  $(document).on('click','.subscription_type .one_time_desktop', function () {
    $('.subscription_type .subscribe_desktop').removeClass('active');
    $(this).addClass('active');
    $('.subscription_type .one_time').trigger('click');
  });

  $(document).on('click','.subscription_type .subscribe_desktop', function () {
    $('.subscription_type .one_time_desktop').removeClass('active');
    $(this).addClass('active');
    $('.subscription_type .subscribe').trigger('click');
  });

  $(window).on('load', function () {
    var sellingPricefirst = $('.main___product').find('.product__info-container .product-form__input input:checked').attr('sell_original_price');
    var sellingPricedecimal = $('.main___product').find('.product__info-container .product-form__input input:checked').attr('sell_original_decimal');
    $('.main___product .selling_plan_sticky .subscription_sticky_cart').find('.price .price__regular .price-item--regular bdi').contents().filter(function() {
      return !$(this).hasClass('price__prefix');
    }).remove();
    $('.main___product .selling_plan_sticky .subscription_sticky_cart').find('.price .price__regular .price-item--regular bdi').append(sellingPricefirst + '<sup class="price__suffix">' + sellingPricedecimal + '</sup>');
  });

  $(document).on('change', '.sticky_prod_id', function () {
    var mainValue = $(this).val();
    $(this).parents('.selling_plan_sticky').find('.selling_prod_id_sticky').val(mainValue);
  });

  $(document).on('change', '.main_product_varid', function () {
    var mainValue = $(this).val();
    $(this).parents('.main___product').find('.selling_plan_sticky .selling_prod_id_sticky').val(mainValue);
  });

  // selling plan end
  
}); 

$(document).ready(function(){
  $(document).on('click', '.customize-btn', function(){
    $('.customize-bundle-wrapper').fadeIn();
  })
  $(document).on('click', '.model-close', function(){
    $('.customize-bundle-wrapper').fadeOut();
  })
  $(document).on('click', '.bundle-btn', function(){
    $(this).addClass('disabled');
    $('.bundle-add-to-cart').click();
    setTimeout(function() {
      $('.customize-bundle-wrapper').fadeOut();
    },1000);
    
  })
$(document).on('click', '.customize-bundle-wrapper .variant-option', function() {
    // Get the clicked element
    let $this = $(this);
    let thisId = $this.attr('data-id');
    
    // Only proceed if the clicked option is not already selected
    if (!$this.hasClass('selected')) {
        $this.addClass('selected');
        $this.siblings().removeClass('selected');
        $('.pre-selected').find('.bundle-product-addon-item .option_items .variant-option[data-id="' + thisId + '"]').siblings().removeClass('selected');
        $('.pre-selected').find('.bundle-product-addon-item .option_items .variant-option[data-id="' + thisId + '"]').addClass('selected');
      let totalPrice = 0;
      let totalComparePrice = 0;
      
      $('.pre-selected .bundle-product-addon-item').each(function() {
          let optionSelected = $(this).find('.option_items .variant-option.selected');
          
          if (optionSelected.length) { // Check if optionSelected exists
              let thisPrice = parseFloat(optionSelected.data('price')) || 0; // Use parseFloat and default to 0
              let thisComparePrice = parseFloat(optionSelected.data('compare-price')) || 0; // Use parseFloat and default to 0
        console.log('thisComparePrice::'+thisComparePrice);
              totalPrice += thisPrice;
              totalComparePrice += thisComparePrice;
          }
      });
      let discount = totalComparePrice - totalPrice;
      let discountPercentage = totalComparePrice > 0 ? (discount / totalComparePrice) * 100 : 0;
      function separateDecimal(value) {
          const whole = Math.floor(value);
          const decimal = (value % 1).toFixed(2).substring(2); // Keeping two decimal places
          return { whole, decimal: `.${decimal}` };
      }
      const totalPriceParts = separateDecimal(totalPrice);
      const totalComparePriceParts = separateDecimal(totalComparePrice);
      const discountParts = separateDecimal(discount);
      
      // Log total prices after the loop
      console.log(`Total Price: ${totalPriceParts.whole} and ${totalPriceParts.decimal}`);
      console.log(`Total Compare Price: ${totalComparePriceParts.whole} and ${totalComparePriceParts.decimal}`);
      console.log(`Discount Percentage: ${discountParts.whole}%`);
      $('.bundle-price .price__regular  .price-item--regular bdi').contents().filter(function() {
        return !$(this).hasClass('price__prefix');
      }).remove();
      $('.bundle-price .price__sale .price__compare .price-item--regular bdi').contents().filter(function() {
        return !$(this).hasClass('price__prefix');
      }).remove();
      $('.bundle-price .price__sale .price-item--sale bdi').contents().filter(function() {
        return !$(this).hasClass('price__prefix');
      }).remove();
      $('.bundle-price .price__regular  .price-item--regular bdi').append(totalPriceParts.whole + '<sup class="price__suffix">' + totalPriceParts.decimal + '</sup>');
      $('.bundle-price .price__sale .price__compare .price-item--regular bdi').append(totalComparePriceParts.whole + '<sup class="price__suffix">' + totalComparePriceParts.decimal + '</sup>');
      $('.bundle-price .price__sale .price-item--sale bdi').append(totalPriceParts.whole + '<sup class="price__suffix">' + totalPriceParts.decimal + '</sup>');
     $('.bundle-price .badge').text(discountParts.whole + '% off');
     
    }
  });


  // $(document).on('click', '.variant-option', function(){
  //   $(this).addClass('selected');
  //   $(this).siblings().removeClass('selected');
  //   let thisId = $(this).attr('data-id');
    
  //   $('.pre-selected').find('.bundle-product-addon-item .option_items .variant-option[data-id="'+thisId+'"]').click();
  //   $('.pre-selected .bundle-product-addon-item .option_items .variant-option.selected').each(function() {
  //       let thisPrice = $(this).data('price');
  //       let thisComparePrice = $(this).data('compare-price');
  //       console.log(`thisPrice: ${thisPrice}, thisComparePrice: ${thisComparePrice}`);
  //   });
  // })
  // $('.bundle-add-to-cart').click(function() {
  //   $(this).addClass('disabled');
  //   let variant_ids = $('.pre-selected .bundle-product-addon-item .variant-option.selected').map(function() {
  //       return $(this).attr('data-id');
  //   }).get();

  //   if (variant_ids.length > 0) {
  //       let items = variant_ids.map(variant_id => ({
  //           id: variant_id,
  //           quantity: 1 // Adjust quantity as needed
  //       }));

  //       // Add items to cart
  //       $.ajax({
  //           type: 'POST',
  //           url: '/cart/add.js',
  //           data: JSON.stringify({ items: items }),
  //           dataType: 'json',
  //           contentType: 'application/json',
  //           success: function(response) {
  //               console.log('Items added to cart:', response);
  //               cartCount();
  //               updateMiniCart();
              
  //             setTimeout(function() {
  //               $('body').addClass('mini-cart--open');
  //                   $('cart-drawer .cart-drawer-container').addClass('menu-opening');
  //                   $('cart-drawer .cart-drawer-container').attr('open', "open");
  //               $('.bundle-add-to-cart, .bundle-btn').removeClass('disabled');
  //               }, 2000);
  //           },
  //           error: function(xhr) {
  //               console.error('Error adding items to cart:', xhr.responseJSON);
  //               // Handle errors here
  //           }
  //       });
  //   } else {
  //       console.log('No variant_ids to add to cart.');
  //   }
  // });

  $('.bundle-add-to-cart').click(function() {
  // Disable the "Add to Cart" button to prevent multiple clicks
  $(this).addClass('disabled');
  
  // Collect the variant IDs of selected products
  let variant_ids = $('.pre-selected .bundle-product-addon-item .variant-option.selected').map(function() {
    return $(this).attr('data-id');
  }).get();

  // Check if there are any selected variants to add to the cart
  if (variant_ids.length > 0) {
    // Prepare the items to add to the cart
    let items = variant_ids.map(variant_id => ({
      id: variant_id,
      quantity: 1 // Adjust the quantity as needed
    }));

    // Make an AJAX request to add items to the cart
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify({ items: items }),
      dataType: 'json',
      contentType: 'application/json',
      success: function(response) {
        // Log the response to check the cart's updated state
        console.log('Items added to cart:', response);
        cartCount();
        // Update the mini cart content
        updateMiniCart();

        // Open the mini cart after a delay (e.g., 2 seconds)
        setTimeout(function() {
          $('body').addClass('mini-cart--open');
          $('cart-drawer .cart-drawer-container').addClass('menu-opening');
          $('cart-drawer .cart-drawer-container').attr('open', "open");

          // Re-enable the "Add to Cart" button
          $('.bundle-add-to-cart, .bundle-btn').removeClass('disabled');
        }, 2000);
      },
      error: function(xhr) {
        console.error('Error adding items to cart:', xhr.responseJSON);
        // Handle any errors here
      }
    });
  } else {
    console.log('No variant_ids to add to cart.');
  }
});

  
  if ($('.custom-bundle-sticky').length) {
    $(window).scroll(function(){
      var stickyOffset = $('.bundle-inside').offset().top;
      var sticky = $('.custom-bundle-sticky'),
          scroll = $(window).scrollTop()- 150
      if (scroll >= stickyOffset ){
         sticky.fadeIn(100);
      }
      else {
        sticky.fadeOut(100);
      }
    });
    // $(window).scroll(function() {
    //   var sticky = $('.custom-bundle-sticky')
    //   if($(window).scrollTop() + $(window).height() > $(document).height() - 505){
    //        sticky.fadeIn(100);
    //    }else {
    //     sticky.fadeOut(100);
    //   }
    // });
  };
})
$( window ).on("load", function() {
  var currentCountry = $('.country-picker').val();
  var currentCountryLowecase = $('.country-picker').val().toLowerCase();
  var $newClass = 'currency-flag currency-flag--'+currentCountryLowecase;
  var currentCounteryName = $('.shipping_container .countery-picker-list').find('li[value="'+currentCountry+'"]').text();
  var $Woking_text = $('.shipping_container .countery-picker-list').find('li[value="'+currentCountry+'"]').attr('data-text');
  // console.log('country-picker::'+currentCountry + 'currentCounteryName:: '+currentCounteryName);
  $('.cdesk_country_text .cdk-country-name .country--name, .ship__text__country').text(currentCounteryName);
  $('.cdesk_country_flag_icon, .currency-name').find('.currency-flag').attr("class",$newClass);
  $('.cdesk_country_flag_icon, .currency-name').find('.currency-flag').attr("data-flag",currentCountry);
  if ($Woking_text !== undefined){
      $('.data-text-update').text($Woking_text);
    }
    else{
      $('.data-text-update').text('5-10 WORKING DAYS');
    }
  addClassAfterDelay();
});

const myDiv = document.querySelector('.country_loader');
function addClassAfterDelay() {
  setTimeout(function() {
    myDiv.classList.add('hide');
  }, 1500);
}
